import type { ReactNode } from 'react'

interface SimulationLayoutProps {
  canvas: ReactNode
  sidebar?: ReactNode
  controls?: ReactNode
}

export function SimulationLayout({
  canvas,
  sidebar,
  controls,
}: SimulationLayoutProps) {
  return (
    <div className="simulation-layout">
      <div className={sidebar ? 'simulation-grid has-sidebar' : 'simulation-grid'}>
        <div className="simulation-canvas-slot">{canvas}</div>
        {sidebar ? <aside className="simulation-sidebar">{sidebar}</aside> : null}
      </div>
      {controls ? <div className="simulation-controls-slot">{controls}</div> : null}
    </div>
  )
}
